import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { useEffect, useState } from 'react';

const CheckOut = ({booking}) => {
  const [stripeError,setStripeError]=useState('')
  const [success,setSuccess]=useState('')
  const [processing,setProcessing]=useState(false)
  const [transactionId,setTransactionId]=useState('')
  const [clientSecret, setClientSecret] = useState("");



    const stripe= useStripe()
    const elements=useElements()
  
  const{price, patient, email, _id}=booking
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    fetch("https://doctor-server-phi.vercel.app/create-payment-intent", {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        authorization: `bearer ${localStorage.getItem('token')}`
    
    },

      body: JSON.stringify({ price}),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, [price]);

    const handleSubmit= async(event)=>{
        event.preventDefault()
        if(!stripe||!elements){
            return
        }


        const card = elements.getElement(CardElement);
        if (card == null) {
            return;
          }

      const {error,paymentMethod }= await stripe.createPaymentMethod({
        type:'card',
        card
      })
       
          if (error) {
            console.log('[error]', error);
            setStripeError(error.message)
          } else{
            setStripeError('')
          }

          setSuccess('')
          setProcessing(true)
          const {paymentIntent, error:confirmError} = await stripe.confirmCardPayment(
           clientSecret,
            {
              payment_method: {
                card: card,
                billing_details: {
                  name: patient,
                  email:email
                },
              },
            },
          );
          if(confirmError){
            setStripeError(confirmError.message)
            return
          }
          if(paymentIntent.status==="succeeded"){
             setSuccess('congrats your payment Completed !')
             setTransactionId(paymentIntent.id)
             const payment={
                    price,
                    transactionId:paymentIntent.id,
                    email,
                    bookingId:_id
             }
             fetch('https://doctor-server-phi.vercel.app/payments', {
              method:"POST",
              headers:{

                "Content-Type": "application/json",

               authorization:`bearer ${localStorage.getItem('token')}`
            
              },
              body:JSON.stringify(payment)

             })
             .then(res=>res.json())
             .then(data=>{
              console.log(data);
              if(data.insertedId){
                setSuccess('congrats your payment Completed !')
                setTransactionId(paymentIntent.id)
              }
             })
             
          }
          setProcessing(false)
         console.log('paymentIntent',paymentIntent);
    

    }
    return (
        <div>
            <form onSubmit={handleSubmit}>
      <CardElement
        options={{
          style: {
            base: {
              fontSize: '16px',
              color: '#424770',
              '::placeholder': {
                color: '#aab7c4',
              },
            },
            invalid: {
              color: '#9e2146',
            },
          },
        }}
      />
      <button className='btn btn-sm btn-primary mt-5' type="submit" disabled={!stripe || !clientSecret || processing}>
        Pay
      </button>
    </form>
    {
      success && <div>
        <p className='text-green-500'>{success}</p>
        <p>your transaction Id: <span>{transactionId}</span></p>
      </div>
    }

    <p className=' text-red-600'>{stripeError}</p>
        </div>
    );
};

export default CheckOut;